import yup from 'src/libraries/validator.library';
import {
    SensitiveCommunitiesListSchema,
    SensitiveCommunitiesFormSchema,
    ISensitiveCommunitiesForm,
  } from 'src/models/sensitive-communities.model';
import { httpClient } from 'src/libraries/http.library';

const http = httpClient();

const services = {
  listGET: async () => {
    return http.get('sensitiveCommunities', { limit: 0 }, SensitiveCommunitiesListSchema);
  },
  updatePUT: async (id: number, data: ISensitiveCommunitiesForm) => {
    return http.put(`sensitiveCommunities/${id}`, data, SensitiveCommunitiesFormSchema);
  },
  addPOST: async (data: ISensitiveCommunitiesForm) => {
    return http.post('sensitiveCommunities', data, SensitiveCommunitiesFormSchema);
  },
  itemDELETE: async (id: number) => {
    return http.delete(`sensitiveCommunities/${id}`, yup.mixed());
  },
};

export default services;
